import axios from 'axios'

const service = axios.create({
    baseURL: 'http://www.gentory.cn/api/',
    timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
      // 在发送请求之前做些什么（例如添加 token）
      const token = localStorage.getItem('token')
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
      return config
    },
    error => {
      // 对请求错误做些什么
      return Promise.reject(error)
    }
  )
  // 响应拦截器
service.interceptors.response.use(
    response => {
      // 对响应数据做处理（根据后端接口结构修改）
      const res = response.data
           
      // 假设接口返回格式为 { code: 200, data: {}, message: 'success' }
      if (res.code !== 200) {
        return Promise.reject(new Error(res.message || 'Error'))
      } else {
        return res.data||res // 直接返回需要的数据
      }
    },
    error => {
      // 对响应错误做处理
      return Promise.reject(error)
    }
  )
export default service


// WEBPACK FOOTER //
// ./src/api/index.js